import { withInstall } from '@ll-plus/utils'

import Trend from './src/trend.vue'

export const LlTrend = withInstall(Trend)
export default LlTrend
export * from './src/trend'

declare module 'vue' {
  export interface GlobalComponents {
    LlTrend: typeof Trend
  }
}
